import { Result } from './model';
var BOOLEAN_REGEX = /^(true|false)$/;
var isBoolean = function (value) {
    return typeof value === 'boolean';
};
var isBooleanString = function (value) {
    return typeof value === 'string' && BOOLEAN_REGEX.test(value);
};
export var asBoolean = function (value, path) {
    if (isBoolean(value)) {
        return Result.ok(value);
    }
    else if (isBooleanString(value)) {
        return Result.ok(value === 'true');
    }
    return Result.error([{ path: path, expected: 'boolean' }]);
};
